module.exports = __webpack_public_path__ + "Assets/tb_aok-1412t_aok-1412_1_lv.jpg";